import React from "react";
import * as appConst from "@app/state/constants";
import { useTranslation } from "react-i18next";

import type { TGroupTreeListItem, TProfTreeListItem } from "@app/types";
export const GroupListIco = ({ e }: { e: any }) => {
  const { data }: { data: TProfTreeListItem | TGroupTreeListItem } = e;
  switch (true) {
    case data.ptlCfgPage === "whoami":
      return <i className={`dx-icon dx-icon-user`} />;
    case data.ptlCfgPage === "distribution":
      return <i className={`dx-icon dx-icon-home`} />;
    case data.ptlCfgPage === appConst.GROUPS_PAGES.GROUP:
      return <i className={`dx-icon dx-icon-group`} />;
    case data.ptlCfgPage === appConst.GROUPS_PAGES.ENVIRONMENT:
      return <i className={`dx-icon dx-icon-globe`} />;
    case data.ptlCfgPage === appConst.GROUPS_PAGES.DIRINFO:
      return <i className={`dx-icon dx-icon-folder`} />;
    case data.ptlCfgPage === appConst.GROUPS_PAGES.BUILDER:
      return <i className={`dx-icon dx-icon-preferences`} />;
    default:
      return <i className={`dx-icon dx-icon-home`} />;
  }
};

export const GroupListTitle = ({ e }: { e: any }) => {
  const { t } = useTranslation();
  return <span>{t(e.data?.ptlTitle || "<title>")}</span>;
};
